import React from "react";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import Badge, { BadgeProps } from "@mui/material/Badge";

interface TooltipIconButtonProps extends IconButtonProps {
  tooltip: React.ReactNode;
  icon: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  badgeProps?: Partial<BadgeProps>;
}

const TooltipIconButton: React.FC<TooltipIconButtonProps> = ({ tooltip, icon, tooltipProps, badgeProps, ...props }) => {
  return (
    <Tooltip {...tooltipProps} title={tooltip}>
      <span>
        <IconButton {...props}>
          <Badge {...badgeProps}>{icon}</Badge>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default TooltipIconButton;
